// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__212HX","ranges":"BmiRanges_ranges__2EmN1"};